module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("Was even he perhaps another person, an unknown and still unmade young man whom chance and time had thrust down there under those yellow animal eyes, those black eyes of women and men and children … so that he might find himself in otherness, in the other-than-self, so that he might discover history outside of history, and time outside of time, and the original pain of things, and himself, outside of the mirror of Narcissus’ pool, in men, on the arid earth?")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("—Carlo Levi")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Christ Stopped at Eboli")])]), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("To be African is to be a bastard. The heart of Africa is metamorphosis.")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("—Breyten Breytenbach")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The True Confessions of an Albino Terrorist")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0